import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {agentsInfoFragments} from "../../fragments/agents/agentInfo/core";
import {Paper, } from "@material-ui/core";
import {buttonsStyle} from "../buttons/styles";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}


function a11yProps(index) {
    return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
}



export const WeekFilter = () => {

    const [value, setValue] = React.useState(0);
    const classes = agentsInfoFragments()
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const tabClasses = buttonsStyle();
    return (
        <div className={classes.root}>
            {/*<AppBar className={classes.appBar} position="static" color="default">*/}
                <Paper
                    style={{
                        // width: "212px",
                        border:'none',
                        background: '#FFFFFF 0% 0% no-repeat padding-box',
                        boxShadow: '0px 0px 6px #8A8A8A29',
                        borderRadius: '18px',
                    }}
                    square
                >
                <Tabs
                    className={classes.buttonsTab}
                    style={{
                        // boxShadow: '0px 0px 6px #8A8A8A29 !important',
                    }}
                    //     width: "212px",
                    //     border:'none',
                    //     background: '#FFFFFF 0% 0% no-repeat padding-box',
                    //     boxShadow: '0px 0px 6px #8A8A8A29',
                    //     borderRadius: '18px',
                    // }}
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                >
                    <Tab label="Today" {...a11yProps(0)} />
                    <Tab label="This Month" {...a11yProps(1)} />
                    <Tab label="Last Month" {...a11yProps(2)} />
                    <Tab label="This Year" {...a11yProps(3)} />
                    <Tab label="Last Year" {...a11yProps(4)} />
                </Tabs>
                </Paper>
            {/*</AppBar>*/}
        </div>
    );
}